import React, { FC, ReactElement } from 'react';
import Table from 'react-bootstrap/Table';
import i18next from 'i18next';
import { Button } from 'react-bootstrap';
import { EnduranceTrainingTypeDto } from '../../../../shared/dtos/enduranceTrainingType.dto';
import { PromMetric } from '../../../../shared/utils/enums';

type EnduranceTrainingTypeTableProps = {
  types: EnduranceTrainingTypeDto[];
  onClick?: (type: EnduranceTrainingTypeDto) => void;
}

const EnduranceTrainingTypeTable: FC<EnduranceTrainingTypeTableProps> = ({ types, onClick }: EnduranceTrainingTypeTableProps): ReactElement => {

  const renderExcludedPromMetrics = (type: EnduranceTrainingTypeDto): string => {
    const metrics: PromMetric[] = type.excludedPromMetrics ?? [];

    if (metrics.length === 0) {
      return '-';
    }

    return metrics.map((metric: PromMetric) => i18next.t(`enduranceTrainingType.promMetric.${metric}`)).join(', ');
  };

  return (
    <Table striped bordered hover responsive className="h-75 overflow-auto">
      <thead>
        <tr>
          <th className="centered-td">{i18next.t('enduranceTrainingType.deName')}</th>
          <th className="centered-td">{i18next.t('enduranceTrainingType.enName')}</th>
          <th className="centered-td">{i18next.t('enduranceTrainingType.trainingMinutes')}</th>
          <th className="centered-td">{i18next.t('enduranceTrainingType.isBillable')}</th>
          <th className="centered-td">{i18next.t('enduranceTrainingType.unit')}</th>
          <th className="centered-td">{i18next.t('enduranceTrainingType.excludedPromMetrics')}</th>
          {onClick && (<th></th>)}
        </tr>
      </thead>
      <tbody>
        {types.map((type) => (
          <tr key={type.id}>
            <td className="centered-td">{type.deName}</td>
            <td className="centered-td">{type.enName}</td>
            <td className="centered-td">{type.trainingMinutes}</td>
            <td className="centered-td">{i18next.t(type.isBillable ? 'enduranceTrainingType.billable' : 'enduranceTrainingType.notBillable')}</td>
            <td className="centered-td">{`${type.unit?.deName ?? '-'} (${type.unit?.deUnit ?? '-'})`}</td>
            <td className="centered-td">{renderExcludedPromMetrics(type)}</td>
            {onClick && (
              <td className='centered-td'>
                <Button variant='dark' onClick={() => {onClick(type);}}>
                  { i18next.t('generic.edit')}
                </Button>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default EnduranceTrainingTypeTable;
